export const appEventsApiFactory = ({ callPostApi }) => ({
    sendEventList: (events, headers) => callPostApi('/app-events', events, headers ? { headers } : {}, true),
});
